import React from 'react';
interface MonopolyCardProps {
  color: string; // Hex code or tailwind class
  title: string;
  price: string;
  features: string[];
  icon?: React.ReactNode;
}
export function MonopolyCard({
  color,
  title,
  price,
  features,
  icon
}: MonopolyCardProps) {
  return <div className="flex flex-col w-full max-w-[280px] bg-white border-2 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,0.2)] transition-transform hover:-translate-y-2 duration-300" data-id="element-8">
      {/* Color Header */}
      <div className="h-24 w-full border-b-2 border-black flex items-center justify-center p-4" style={{
      backgroundColor: color
    }} data-id="element-9">
        <div className="text-4xl opacity-80 mix-blend-multiply" data-id="element-10">{icon}</div>
      </div>

      {/* Content */}
      <div className="flex-1 p-6 flex flex-col items-center text-center" data-id="element-11">
        <h3 className="font-['Koulen'] text-2xl uppercase tracking-wide mb-4 leading-none text-black" data-id="element-12">
          {title}
        </h3>

        <div className="w-full space-y-2 mb-6 font-['Aleo'] text-sm text-gray-700" data-id="element-13">
          {features.map((feature, idx) => <div key={idx} className="flex justify-between w-full border-b border-gray-200 pb-1 last:border-0" data-id="element-14">
              <span data-id="element-15">{feature}</span>
            </div>)}
        </div>
      </div>

      {/* Price Footer */}
      <div className="mt-auto p-3 border-t-2 border-black text-center" data-id="element-16">
        <span className="font-['Koulen'] text-xl" data-id="element-17">CENA {price} ZŁ</span>
      </div>
    </div>;
}